import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import {
  M09_MODULE_INFO,
  M09_TOPICS,
  getAllM09Problems
} from '../data/mathExercises/M09_PolynomialsRemainderFactorTheorem.js';

const M09PolynomialsRemainderFactorTheoremExercise = ({ onProgress }) => {
  const topics = M09_TOPICS;
  const problems = getAllM09Problems();
  const moduleInfo = M09_MODULE_INFO;

  return (
    <ExerciseInterface
      moduleInfo={moduleInfo}
      topics={topics}
      problems={problems}
      onProgress={onProgress}
      className="m09-exercise"
    />
  );
};

export default M09PolynomialsRemainderFactorTheoremExercise; 